export default { 
    env: 'development',
    api_url: 'http://localhost:8080/api',
    graphql_url: 'http://localhost:8080/graphql',
    socket_url: 'ws://localhost:8080/socket',
    legacy_url: 'http://localhost:8080',
    external_url: 'http://localhost:8080/externo',
}
